import { render, staticRenderFns } from "./PresentContentMobile.vue?vue&type=template&id=503589aa&scoped=true&"
import script from "./PresentContentMobile.vue?vue&type=script&lang=js&"
export * from "./PresentContentMobile.vue?vue&type=script&lang=js&"
import style0 from "./PresentContentMobile.vue?vue&type=style&index=0&id=503589aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503589aa",
  null
  
)

export default component.exports